/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';
import { ENROLLMENT_ROUTE, THEMES } from '../../common/constants';
import ThemeVariablesRoot from '../../common/components/theme/ThemeVariablesRoot';
import '../authhome/AuthHomeStyles.scss';
import DeepLink from './DeepLink';
import EnrollmentLink from './EnrollmentLink';

const courseDeepLink = {
  path: '/home2/courses/:courseId',
  exact: true,
  services: [],
  stores: [],
  render: props => (
    <DeepLink {...props} />
  )
};

const enrollmentDeepLink = {
  path: ENROLLMENT_ROUTE,
  exact: true,
  services: [],
  stores: [],
  render: props => (
    <ThemeVariablesRoot theme={THEMES.LIGHT}>
      <EnrollmentLink {...props} />
    </ThemeVariablesRoot>
  )
};

export default [
  courseDeepLink,
  enrollmentDeepLink
];
